import { buildCommunityPostPath } from "../models/community.model";
import { htmlFragmentToText } from "./html-text.utils";

/** How much of the post a share title carries when the post has no subject. */
export const SHARE_TITLE_MAX = 80;

/** What a share hands the platform: the post's public link and a line to go with it. */
export interface CommunityPostShare {
  url: string;
  /** The subject, or the start of the body — the line a share sheet or email leads with. */
  title: string;
}

/**
 * The link and title for sharing a community post. Web and mobile both call this, so a post
 * shared from the app and one shared from the browser land on the same URL.
 *
 * `fenderUrl` is the environment's (it ends in "/").
 *
 * Community posts only. Beta posts are never shared — they're bug reports on unreleased
 * products — so there is deliberately no beta option here.
 */
export function communityPostShare(post: any, opts: { fenderUrl: string; communityStringId?: string }): CommunityPostShare {
  const url =
    opts.fenderUrl +
    buildCommunityPostPath({
      postId: post?.id,
      communityStringId: post?.community_string_id || opts.communityStringId,
    });
  return { url, title: shareTitle(post) };
}

/** A `mailto:` that opens the reader's mail app with the post's title and link filled in. */
export function communityPostShareMailto(share: CommunityPostShare): string {
  const subject = share.title || "A post on the Fender community";
  const body = share.title ? `${share.title}\n\n${share.url}` : share.url;
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function shareTitle(post: any): string {
  const subject = htmlFragmentToText(post?.subject);
  if (subject) return subject;
  const body = htmlFragmentToText(post?.message);
  if (body.length <= SHARE_TITLE_MAX) return body;
  // Cut at a word, so the title never ends mid-word.
  const cut = body.slice(0, SHARE_TITLE_MAX);
  const lastSpace = cut.lastIndexOf(" ");
  return (lastSpace > SHARE_TITLE_MAX / 2 ? cut.slice(0, lastSpace) : cut).trimEnd() + "…";
}
